import { render, staticRenderFns } from "./Geteway.vue?vue&type=template&id=f645a234"
import script from "./Geteway.vue?vue&type=script&lang=js"
export * from "./Geteway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports